import { useCallback } from 'react';
import { Box, Text } from '@frameio/vapor';
import { useSearchHistoryData } from '../../../../../shared/contexts';
import { useTrackRecentSearchSelected } from '../../../../../shared/contexts/SearchAnalyticsContext';
import { SearchCell } from '../shared';
import TEXT from './generated/TEXT/RecentSearchesInitial';

TEXT.DEFINE({
  /** Section title for recent search history */
  title: 'History',
});

type RecentSearchesProps = {
  onClickRecentSearch: (query: string) => void;
};

export const RecentSearches = ({
  onClickRecentSearch,
}: RecentSearchesProps) => {
  const { searchHistory, hasSearchHistory, removeRecentSearch } =
    useSearchHistoryData();
  const trackRecentSearchSelected = useTrackRecentSearchSelected();

  const handleOnClickRecentSearch = useCallback(
    (query: string) => {
      trackRecentSearchSelected(query);
      onClickRecentSearch(query);
    },
    [onClickRecentSearch, trackRecentSearchSelected]
  );

  if (!hasSearchHistory) return null;

  return (
    <div>
      <Box alignItems="center" height={32} padding={8}>
        <Text color="tertiary" fontWeight="medium" variant="secondary">
          {TEXT.title}
        </Text>
      </Box>
      <Box
        alignItems="flex-start"
        display="flex"
        flexDirection="column"
        width="100%"
      >
        {searchHistory.map(({ mode, query }) => (
          <SearchCell
            key={`${mode}-${query}`}
            onClick={handleOnClickRecentSearch}
            onRemove={() => removeRecentSearch({ mode, query })}
            searchQuery={query}
          />
        ))}
      </Box>
    </div>
  );
};
